export default "__VITE_ASSET__Dxd8Io2q__"